import React from 'react'
import styles from './warning-message.styles'
import injectSheet from 'react-jss'

const WarningMessage = ({ classes, children }) => (
  <span className={classes.warning}>{children}</span>
)

export default injectSheet(styles)(WarningMessage)
